import { useEffect, useState } from 'react'

import { type AuthState, useAuth } from '@/lib/auth-store'
import { ensureAuth } from '@/lib/session'

const ANONYMOUS: AuthState<'restaurant'> = { status: 'anonymous' }

/**
 * The customer's auth state, probed once: `/me` says whether the cookie is
 * live — a dead one orders and tracks anonymously (G2), so its presence is
 * never trusted. A probe that failed outright reads as anonymous rather than
 * leaving a page waiting on `unknown`.
 */
export function useCustomerAuth(): AuthState<'restaurant'> {
  const auth = useAuth('restaurant')
  const [probeFailed, setProbeFailed] = useState(false)
  useEffect(() => {
    void ensureAuth('restaurant').catch(() => setProbeFailed(true))
  }, [])
  return auth.status === 'unknown' && probeFailed ? ANONYMOUS : auth
}
